export const Global = {
  apiUrl: "https://trucks-back.tegetabusiness.ge/api/",
};

export const ProjectTitle = "TTB";
